const Shop = ({ color = "var(primary100)", size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0098 20.7733V17.7156C10.0098 16.9351 10.6472 16.3023 11.4334 16.3023H14.3076C14.6852 16.3023 15.0473 16.4512 15.3143 16.7163C15.5813 16.9813 15.7313 17.3408 15.7313 17.7156V20.7733C15.7289 21.0978 15.8571 21.4099 16.0874 21.6402C16.3177 21.8705 16.6311 22 16.9579 22H18.9188C19.8346 22.0023 20.7138 21.6428 21.3622 21.0008C22.0106 20.3588 22.375 19.487 22.375 18.5778V9.86686C22.375 9.13246 22.0471 8.43584 21.4796 7.96467L14.809 2.67587C13.6487 1.74856 11.9861 1.7785 10.8604 2.74698L4.34201 7.96467C3.74774 8.42195 3.39255 9.12064 3.375 9.86686V18.5689C3.375 20.4639 4.92238 22 6.83117 22H8.74729C9.42623 22 9.978 21.4562 9.98292 20.7822L10.0098 20.7733Z"
        fill={color}
      />
    </svg>
  );
};

export default Shop;
